import { combineReducers } from 'redux';
import {handleActions, createAction} from 'redux-actions';
import {createThunkActionCreator} from 'utils/redux/createThunkActionCreator';
import * as thunkActionConstants from 'utils/redux/thunkActionConstants';
import * as customersApi from '../../services/api/apiWithOtp/auth2';
import * as authConstants from './constants2';
import {LOGIN_RESET} from "../../constants/authConstants";
import {getSeccondsDiff, getPSTTimeNow} from "../../utils/dateHelper";

export function otpFormReset() {
  return {
    type: authConstants.OTP_RESET,
  };
}

export function otpFocusAfterFail() {
  return {
    type: authConstants.OTP_FOCUS_AFTER_FAIL,
  };
}

export function forgotPasswordOtpFormReset() {
  return {
    type: authConstants.FORGOT_PASSWORD_OTP_RESET,
  };
}

export function forgotPasswordOtpFocusAfterFail() {
  return {
    type: authConstants.FORGOT_PASSWORD_OTP_FOCUS_AFTER_FAIL,
  };
}

export function otpTypeRegisterReset() {
  return {
    type: authConstants.OTP_TYPE_REGISTER_RESET,
  };
}

export function otpTypeForgotPasswordReset() {
  return {
    type: authConstants.FORGOT_PASSWORD_OTP_TYPE_RESET,
  };
}

const forgotPasswordReducerMap = {};

export const forgotPasswordResetAction = createAction(authConstants.ACTION_FORGOT_PASSWORD_RESET);
forgotPasswordReducerMap[authConstants.ACTION_FORGOT_PASSWORD_RESET] = (state, action) => {
  return {
    ...action
  };
};

export const forgotPasswordClearRequestFailure = createAction(authConstants.ACTION_FORGOT_PASSWORD_CLEAR_FAILURE);
forgotPasswordReducerMap[authConstants.ACTION_FORGOT_PASSWORD_CLEAR_FAILURE] = (state) => {
  return {
    ...state,
    isFPRequestFail: false,
    blockedTimeLeft: undefined,
    isLoadingFPRequest: false,
    isFPRequestSuccess: false,
    fPError: undefined,
    failReason: undefined,
  };
};

export const forgotPasswordRequestAction = createThunkActionCreator(authConstants.ACTION_FORGOT_PASSWORD_REQUEST, (ssn4Digits, userName, userNameType) => {
  return customersApi.forgotPassword(ssn4Digits, userName, userNameType);
});

forgotPasswordReducerMap[authConstants.ACTION_FORGOT_PASSWORD_REQUEST] = (state, action) => {
  let failReason;
  let blockedTimeLeft;
  let isFullSsnValidationRequired = state.isFullSsnValidationRequired;
  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {
        ...state,
        isLoadingFPRequest: true,
        isFPRequestSuccess: false,
        isFPRequestFail: false,
      };
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {...state,
        isLoadingFPRequest: false,
        isFPRequestSuccess: true,
        isFPRequestFail: false,
        phoneLast4digits: action.payload.phoneLast4digits,
        fPRequestToken: action.payload.token,
        firstName: action.payload.firstName,
      };
    case thunkActionConstants.ACTION_STATUS_FAIL:
      switch(action.error.code) {
        case authConstants.FAIL_ERROR_CODE_EXISTS:
          failReason = authConstants.FAIL_REASON_ALREADY_EXISTS;
          break;
        case authConstants.FAIL_ERROR_CODE_LOCKED:
          failReason = authConstants.FAIL_REASON_LOCKED;
          break;
        case authConstants.SSN_VALIDATION_BLOCKED: {
          const blockedUntilDate = new Date(action.error.message);
          blockedTimeLeft = getSeccondsDiff(blockedUntilDate, getPSTTimeNow());
          failReason = authConstants.SSN_VALIDATION_BLOCKED;
          break;
        }
        case authConstants.ACCOUNT_NOT_REGISTERED:
          failReason = authConstants.ACCOUNT_NOT_REGISTERED;
          break;
        case authConstants.FULL_SSN_VALIDATION: {
          isFullSsnValidationRequired = true;
          failReason = authConstants.FAIL_REASON_NOT_FOUND;
          break;
        }
        case authConstants.SHORT_SSN_VALIDATION: {
          isFullSsnValidationRequired = false;
          failReason = authConstants.FAIL_REASON_NOT_FOUND;
          break;
        }
        case authConstants.ENTITY_NOT_FOUND:
          failReason = authConstants.FAIL_REASON_NOT_FOUND;
          break;
      }
      return {
        isFullSsnValidationRequired,
        blockedTimeLeft,
        isLoadingFPRequest: false,
        isFPRequestSuccess: false,
        isFPRequestFail: true,
        fPError: action.error,
        failReason: failReason,
      };
  }
};

forgotPasswordReducerMap['@@redux-form/CHANGE'] = (state) => {
  return {
    ...state,
    isFPRequestFail: false,
    fPError: undefined,
    failReason: undefined,
  };
};

forgotPasswordReducerMap[authConstants.FORGOT_PASSWORD_OTP_TYPE_RESET] = (state) => {
  return {
    ...state,
    otpType: undefined,
    isLoadingOtpType: false,
    isOtpTypeSuccess: false,
    isOtpTypeFail: false,
    otpTypeError: undefined,
  };
};

export const fPSendOtpType = createThunkActionCreator(authConstants.FORGOT_PASSWORD_SEND_OTP_TYPE, ({otpType, token}) => {
  return customersApi.forgotPasswordSendOtpType(otpType, token);
});

forgotPasswordReducerMap[authConstants.FORGOT_PASSWORD_SEND_OTP_TYPE] = (state, action) => {
  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {
        ...state,
        otpType: action.args[0].otpType,
        isLoadingOtpType: true,
        isOtpTypeSuccess: false,
        isOtpTypeFail: false,
        otpTypeError: undefined,
      };
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {
        ...state,
        otpTypeToken: action.payload.token,
        isLoadingOtpType: false,
        isOtpTypeSuccess: true,
        isOtpTypeFail: false,
        otpTypeError: undefined,
      };
    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {
        ...state,
        isLoadingOtpType: false,
        isOtpTypeSuccess: false,
        isOtpTypeFail: true,
        otpTypeError: action.error,
      };
  }
};

export const forgotPasswordVerifyOtp = createThunkActionCreator(authConstants.FORGOT_PASSWORD_ACTION_VERIFY_OTP, (verificationCode, token) => {
  return customersApi.forgotPasswordVerifyOtp(verificationCode, token);
});


forgotPasswordReducerMap[authConstants.FORGOT_PASSWORD_ACTION_VERIFY_OTP] = (state, action) => {
  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {
        ...state,
        isLoadingOtp: true,
        isOtpSuccess: false,
        isOtpFail: false,
        otpVerifyError: undefined,
      };
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {
        ...state,
        otpToken: action.payload.token,
        firstName: action.payload.firstName,
        isLoadingOtp: false,
        isOtpSuccess: true,
        isOtpFail: false,
        otpVerifyError: undefined,
      };
    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {
        ...state,
        isOtpSuccess: false,
        isOtpFail: true,
        otpVerifyError: action.error,
        isLoadingOtp: false,
        otpAttempts: state.otpAttempts + 1,
      };
  }
};

export const forgetPasswordCreatePassword = createThunkActionCreator(authConstants.FORGOT_PASSWORD_CREATE_PASSWORD, (password, token) => {
  return customersApi.forgetPasswordCreatePassword(password, token);
});

forgotPasswordReducerMap['@@redux-form/CHANGE'] = (state) => {
  return {
    ...state,
    isCreatePasswordFail: false,
  };
};

forgotPasswordReducerMap[authConstants.FORGOT_PASSWORD_CREATE_PASSWORD] = (state, action) => {
  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {
        ...state,
        isLoadingCreatePassword: true,
        isCreatePasswordSuccess: false,
        isCreatePasswordFail: false,
        statusText: '',
        createNewPasswordError: undefined,
      };
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {
        ...state,
        isLoadingCreatePassword: false,
        isCreatePasswordSuccess: true,
        isCreatePasswordFail: false,
        statusText: '',
        createNewPasswordError: undefined,
      };
    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {
        ...state,
        isLoadingCreatePassword: false,
        isCreatePasswordSuccess: false,
        isCreatePasswordFail: true,
        createNewPasswordError: action.error,
        statusText: 'Failed to create password, please try again.' // todo: map error when available
      };
  }
};


forgotPasswordReducerMap[authConstants.FORGOT_PASSWORD_OTP_RESET] = (state) => {
  return {
    ...state,
    otpToken: undefined,
    isLoadingOtp: false,
    isOtpSuccess: false,
    isOtpFail: false,
    otpAttempts: 0,
  };
};

forgotPasswordReducerMap[authConstants.FORGOT_PASSWORD_OTP_FOCUS_AFTER_FAIL] = (state) => {
  return {
    ...state,
    isLoadingOtp: false,
    isOtpSuccess: false,
    isOtpFail: false,
  };
};

forgotPasswordReducerMap[LOGIN_RESET] = () => {
  return {};
};

const registerReducerMap = {};
export const registerResetAction = createAction(authConstants.ACTION_REGISTER_RESET);
registerReducerMap[authConstants.ACTION_REGISTER_RESET] = (state, action) => {
  return {
    ...action
  };
};

export const toggleRememberMe = createAction(authConstants.ACTION_REMEMBER_ME_CHANGE);
registerReducerMap[authConstants.ACTION_REMEMBER_ME_CHANGE] = (state, action) => {
  return {
    ...state,
    rememberMe: action.payload
  };
};

registerReducerMap[authConstants.OTP_RESET] = (state) => {
  return {
    ...state,
    otpToken: undefined,
    isLoadingOtp: false,
    isOtpSuccess: false,
    isOtpFail: false,
    otpAttempts: 0,
  };
};

registerReducerMap[authConstants.OTP_FOCUS_AFTER_FAIL] = (state) => {
  return {
    ...state,
    isLoadingOtp: false,
    isOtpSuccess: false,
    isOtpFail: false,
  };
};

export const registerClearRequestFailure = createAction(authConstants.ACTION_REGISTER_CLEAR_FAILURE);
registerReducerMap[authConstants.ACTION_REGISTER_CLEAR_FAILURE] = (state) => {
  return {
    ...state,
    isLoadingRegister: false,
    isRegisterFail: false,
    isRegisterSuccess: false,
    registerError: undefined,
    blockedTimeLeft: undefined,
    isLoadingOtp: false,
    isOtpSuccess: false,
    isOtpFail: false,
  };
};


export const registerRequestAction = createThunkActionCreator(authConstants.ACTION_REGISTER_REQUEST, (ssn4Digits, userName, userNameType) => {
  return customersApi.registerAccount(ssn4Digits, userName, userNameType);
});

registerReducerMap[authConstants.ACTION_REGISTER_REQUEST] = (state, action) => {
  return {
    ...state,
    registerInfo: action.payload
  };
};

registerReducerMap[authConstants.ACTION_REGISTER_REQUEST] = (state, action) => {
  let registerError = action.error;
  let isFullSsnValidationRequired = state.isFullSsnValidationRequired;
  let blockedTimeLeft;

  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {
        ...state,
        isLoadingRegister: true,
        isRegisterSuccess: false,
        isRegisterFail: false,
      };
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {
      ...state,
        isLoadingRegister: false,
        isRegisterSuccess: true,
        isRegisterFail: false,
        phoneLast4digits: action.payload.phoneLast4digits,
        signUpRequestToken: action.payload.token,
        firstName: action.payload.firstName,
      };
    case thunkActionConstants.ACTION_STATUS_FAIL:
      switch(action.error.code) {
        case authConstants.SSN_VALIDATION_BLOCKED: {
          const blockedUntilDate = new Date(action.error.message);
          blockedTimeLeft = getSeccondsDiff(blockedUntilDate, getPSTTimeNow());
          registerError.code = authConstants.SSN_VALIDATION_BLOCKED;
          break;
        }
        case authConstants.FULL_SSN_VALIDATION: {
          isFullSsnValidationRequired = true;
          registerError.code = authConstants.ENTITY_NOT_FOUND;
          break;
        }
        case authConstants.SHORT_SSN_VALIDATION: {
          isFullSsnValidationRequired = false;
          registerError.code = authConstants.ENTITY_NOT_FOUND;
          break;
        }
    }

      return {
        ...state,
        isLoadingRegister: false,
        ...action,
        otpAttempts: state.attempts + 1,
        isRegisterFail: true,
        isRegisterSuccess: false,
        registerError,
        isFullSsnValidationRequired,
        blockedTimeLeft,
      };
  }
};

registerReducerMap[authConstants.OTP_TYPE_REGISTER_RESET] = (state) => {
  return {
    ...state,
    otpType: undefined,
    isLoadingOtpType: false,
    isOtpTypeSuccess: false,
    isOtpTypeFail: false,
    otpTypeError: undefined,
  };
};

export const sendOtpType = createThunkActionCreator(authConstants.SEND_OTP_TYPE, ({otpType, token}) => {
  return customersApi.registerSendOtpType(otpType, token);
});

registerReducerMap[authConstants.SEND_OTP_TYPE] = (state, action) => {
  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {
        ...state,
        otpType: action.args[0].otpType,
        isLoadingOtpType: true,
        isOtpTypeSuccess: false,
        isOtpTypeFail: false,
        otpTypeError: undefined,
      };
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {
        ...state,
        otpTypeToken: action.payload.token,
        isLoadingOtpType: false,
        isOtpTypeSuccess: true,
        isOtpTypeFail: false,
        otpTypeError: undefined,
      };
    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {
        ...state,
        isLoadingOtpType: false,
        isOtpTypeSuccess: false,
        isOtpTypeFail: true,
        otpTypeError: action.error,
      };
  }
};

export const verifyOtp = createThunkActionCreator(authConstants.ACTION_VERIFY_OTP, (verificationCode, token) => {
  return customersApi.registerVerifyOtp(verificationCode, token);
});

registerReducerMap[authConstants.ACTION_VERIFY_OTP] = (state, action) => {
  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {
        ...state,
        isLoadingOtp: true,
        isOtpSuccess: false,
        isOtpFail: false,
        otpVerifyError: undefined,
      };
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {
        ...state,
        otpToken: action.payload.token,
        isLoadingOtp: false,
        isOtpSuccess: true,
        isOtpFail: false,
        otpVerifyError: undefined,
      };
    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {
        ...state,
        isOtpSuccess: false,
        isOtpFail: true,
        otpVerifyError: action.error,
        isLoadingOtp: false,
        otpAttempts: state.otpAttempts + 1,
      };
  }
};

export const createPasswordResetAction = createAction(authConstants.CREATE_PASSWORD_RESET);

registerReducerMap[authConstants.CREATE_PASSWORD_RESET] = (state) => {
  return {
    ...state,
    isLoadingCreatePassword: false,
    isCreatePasswordSuccess: false,
    isCreatePasswordFail: false,
    statusText: '',
  };
};

export const createPassword = createThunkActionCreator(authConstants.CREATE_PASSWORD, (password, token) => {
  return customersApi.createPassword(password, token);
});

registerReducerMap[authConstants.CREATE_PASSWORD] = (state, action) => {
  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {
        ...state,
        isLoadingCreatePassword: true,
        isCreatePasswordSuccess: false,
        isCreatePasswordFail: false,
        registerCreatePasswordError: undefined,
        statusText: '',
      };
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {
        ...state,
        isLoadingCreatePassword: false,
        isCreatePasswordSuccess: true,
        isCreatePasswordFail: false,
        registerCreatePasswordError: undefined,
        statusText: '',
      };
    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {
        ...state,
        isLoadingCreatePassword: false,
        isCreatePasswordSuccess: false,
        isCreatePasswordFail: true,
        registerCreatePasswordError: action.error,
        statusText: 'Failed to create password, please try again.' // todo: map error when available
      };
  }
};

registerReducerMap[LOGIN_RESET] = () => {
  return {};
};

const resetPasswordReducerMap = {}; // keeping old (before otp) pages alive just to redirect from them

const updateEmailMap = {};

export const verifyEmailByTokenAction = createThunkActionCreator(authConstants.VERIFY_EMAIL_BY_TOKEN, (token) => {
  return customersApi.updateEmailByToken(token);
});

updateEmailMap[authConstants.VERIFY_EMAIL_BY_TOKEN] = (state, action) => {
  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {
        ...state,
        isLoadingVerifyEmail: true,
        isVerifyEmailSuccess: false,
        isVerifyEmailFail: false,
      };
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {
        ...state,
        isLoadingVerifyEmail: false,
        isVerifyEmailSuccess: true,
        isVerifyEmailFail: false,
      };
    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {
        ...state,
        isLoadingVerifyEmail: false,
        isVerifyEmailSuccess: false,
        isVerifyEmailFail: true,
        VerifyEmailError: action.error,
      };
  }
};

export const reducer = combineReducers({
  forgotPassword: handleActions(forgotPasswordReducerMap, {}),
  register: handleActions(registerReducerMap, {}),
  resetPassword: handleActions(resetPasswordReducerMap, {}),
  updateEmail: handleActions(updateEmailMap, {}),
});



// WEBPACK FOOTER //
// ./src/auth/authWithOtp/redux2.js